import { render, staticRenderFns } from "./form12b.vue?vue&type=template&id=4b03274a&scoped=true&"
import script from "./form12b.vue?vue&type=script&lang=js&"
export * from "./form12b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b03274a",
  null
  
)

export default component.exports